import { VitalParameters } from '@/api/apis/case';
import { ClinicalGridItem } from './ClinicalGridItem';

export const VitalsGrid = ({ vitals }: { vitals?: VitalParameters }) => {
  const {
    heartRate,
    systolicBloodPressure,
    diastolicBloodPressure,
    meanArterialPressure,
    respiratoryRate,
    oxygenSaturation,
  } = vitals ?? {};

  return (
    <div className="flex-1 grid grid-cols-3 grid-rows-2 gap-y-3 pt-2 px-2">
      <ClinicalGridItem name="Heart Rate" unit="T/m" value={heartRate} />
      <ClinicalGridItem name="Systolic BP" unit="mmHg" value={systolicBloodPressure} />
      <ClinicalGridItem name="Diastolic BP" unit="mmHg" value={diastolicBloodPressure} />
      <ClinicalGridItem name="Mean AP" unit="mmHg" value={meanArterialPressure} />
      <ClinicalGridItem name="Respiratory Rate" unit="T/m" value={respiratoryRate} />
      <ClinicalGridItem name="Oxygen Saturation" unit="%" value={oxygenSaturation} />
    </div>
  );
};
